import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { BarChart3, FileText, CreditCard } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useRestaurant } from '@/context/RestaurantContext'
import { isFeatureEnabled } from '@/lib/features'

interface MobileBottomNavProps {
  isSidebarOpen?: boolean
}

export default function MobileBottomNav({ isSidebarOpen = false }: MobileBottomNavProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const { currentRestaurant } = useRestaurant()

  const allNavItems = [
    {
      name: 'Dashboard',
      feature: 'dashboard',
      href: '/dashboard',
      icon: BarChart3,
      label: 'Dashboard'
    },
    {
      name: 'Sales',
      feature: 'sales-reports',
      href: '/sales-reports',
      icon: FileText,
      label: 'Sales'
    },
    {
      name: 'Subscription',
      feature: 'subscription',
      href: '/subscription',
      icon: CreditCard,
      label: 'Subscription'
    }
  ]

  const navItems = allNavItems.filter(item => isFeatureEnabled(currentRestaurant, item.feature))

  // Don't show bottom nav when sidebar is open on mobile
  if (isSidebarOpen || navItems.length === 0) {
    return null
  }

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-card border-t shadow-lg" style={{ paddingBottom: '7px' }}>
      <nav className="flex items-center justify-around px-2 pb-safe">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = location.pathname === item.href

          return (
            <button
              key={item.name}
              onClick={() => navigate(item.href)}
              className={cn(
                "flex flex-col items-center justify-center flex-1 py-1 space-y-0.5 transition-all duration-200",
                isActive
                  ? "text-restaurant-primary"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <div className={cn(
                "flex items-center justify-center w-9 h-9 rounded-xl transition-all duration-200",
                isActive
                  ? "bg-restaurant-primary/10"
                  : "hover:bg-accent"
              )}>
                <Icon className={cn(
                  "h-5 w-5",
                  isActive && "stroke-[2.5]"
                )} />
              </div>
              <span className={cn(
                "text-xs font-medium",
                isActive && "font-semibold"
              )}>
                {item.label}
              </span>
            </button>
          )
        })}
      </nav>
    </div>
  )
}
